import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import CustomInputField from "components/common/CustomInputField";
import { successToaster, ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import BtnCustom from "components/common/btn-custom";
import { useCallback, useEffect, useState } from "react";
import CustomPaginatedSelect from "components/common/CustomPaginatedSelect";
import { InputGroup } from "reactstrap";
import ImageUploadCustom from "components/CustomUpload/ImageUploadCustom";
import { ImageUrlToFile } from "utils/ImageUrlToFile";
import { AttributesFields } from "constant/Fields";
import { GetAttributesFilterOptionsAPI } from "network/productAPI";
import { AttributesImageFields } from "constant/Fields";
import { GetAttributeAPI } from "network/productAPI";
import { CreateAttributeAPI } from "network/productAPI";
import { AttributesSchema } from "components/schema/AttributesSchema";
import { UpdateAttributeAPI } from "network/productAPI";
import { formatDecimalWithComma } from "utils/formatDecimalWithComma";
import CountryListSelect from "components/common/CounteryListSlecte";
import { debounce } from "utils/debounce";
import { SearchWineData } from "network/wineDataSetAPI";
import { mediaUrl } from "utils/mediaUrl";

const AttributesFrom = ({ sectionData, productId, editData }) => {
  const { t } = useTranslation("products");
  const pageSize = 10;
  const [errorImg, setErrorImg] = useState({});
  const [codFilterOption, setCodFilterOption] = useState([]);
  const [isFirstRender, setIsFirstRender] = useState(true);
  // const [attributes, setAttributes] = useState([]);

  const [formInitialValues, setFormInitialValues] = useState({
    name: editData?.name || "",
    description: editData?.description || "",
    front_bottle_image: editData?.front_bottle_image
      ? mediaUrl(editData?.front_bottle_image)
      : null,
    back_bottle_image: editData?.back_bottle_image
      ? mediaUrl(editData?.back_bottle_image)
      : null,
    front_label_image: editData?.front_label_image
      ? mediaUrl(editData?.front_label_image)
      : null,
    back_label_image: editData?.back_label_image
      ? mediaUrl(editData?.back_label_image)
      : null,
    ean: editData?.ean || "",
    winery: editData?.winery || "",
    vintage: formatDecimalWithComma(editData?.vintage) || "",
    denomination: editData?.denomination || "",
    gradation: formatDecimalWithComma(editData?.gradation) || "",
    vinification: editData?.vinification || "",
    terroir: editData?.terroir || "",
    region: editData?.region || "",
    format: formatDecimalWithComma(editData?.format) || "",
    country: editData?.country ?? null,
    natural: editData?.natural ?? null,
    bio: editData?.bio ?? null,
    have_sulphite: editData?.have_sulphite ?? null,
    biodynamic: editData?.biodynamic ?? null,
    conventional: editData?.conventional ?? null,
    energy: editData?.energy || "",
    fat: formatDecimalWithComma(editData?.fat) || "",
    saturated_fat: formatDecimalWithComma(editData?.saturated_fat) || "",
    carbohydrate: formatDecimalWithComma(editData?.carbohydrate) || "",
    sugar: formatDecimalWithComma(editData?.sugar) || "",
    protein: formatDecimalWithComma(editData?.protein) || "",
    salt: formatDecimalWithComma(editData?.salt) || "",
    ingredients: editData?.ingredients || "",
    fermentation: editData?.fermentation || "",
    colour: editData?.colour || "",
    taste: editData?.taste || "",
    pairing: editData?.pairing || "",
    // is_active: editData?.is_active ?? true,
    // is_approved: editData?.is_approved ?? true,
  });

  const resetState = () => {
    setErrorImg({});
    setCodFilterOption([]);
  };
  useEffect(() => {
    resetState();
  }, [sectionData]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  // const initialValues = {
  //   name: attributes?.name || editData?.name || "",
  //   description: attributes?.description || editData?.description || "",

  //   front_bottle_image:
  //     attributes?.front_bottle_image || editData?.front_bottle_image || null,
  //   back_bottle_image:
  //     attributes?.back_bottle_image || editData?.back_bottle_image || null,
  //   front_label_image:
  //     attributes?.front_label_image || editData?.front_label_image || null,
  //   back_label_image:
  //     attributes?.back_label_image || editData?.back_label_image || null,
  //   ean: attributes?.ean || editData?.ean || "",
  //   winery: attributes?.winery || editData?.winery || "",
  //   vintage:
  //     formatDecimalWithComma(attributes?.vintage) ||
  //     formatDecimalWithComma(editData?.vintage) ||
  //     "",
  //   denomination: attributes?.denomination || editData?.denomination || "",
  //   gradation:
  //     formatDecimalWithComma(attributes?.gradation) ||
  //     formatDecimalWithComma(editData?.gradation) ||
  //     "",
  //   vinification: attributes?.vinification || editData?.vinification || "",
  //   terroir: attributes?.terroir || editData?.terroir || "",
  //   region: attributes?.region || editData?.region || "",
  //   format:
  //     formatDecimalWithComma(attributes?.format) ||
  //     formatDecimalWithComma(editData?.format) ||
  //     "",
  //   country: attributes?.country ?? editData?.country ?? null,
  //   natural: attributes?.natural ?? editData?.natural ?? null,
  //   bio: attributes?.bio ?? editData?.bio ?? null,
  //   no_sulphite: attributes?.no_sulphite ?? editData?.no_sulphite ?? null,
  //   biodynamic: attributes?.biodynamic ?? editData?.biodynamic ?? null,
  //   conventional: attributes?.conventional ?? editData?.conventional ?? null,
  //   energy: attributes?.energy || editData?.energy || "",
  //   fat:
  //     formatDecimalWithComma(attributes?.fat) ||
  //     formatDecimalWithComma(editData?.fat) ||
  //     "",
  //   saturated_fat:
  //     formatDecimalWithComma(attributes?.saturated_fat) ||
  //     formatDecimalWithComma(editData?.saturated_fat) ||
  //     "",
  //   carbohydrate:
  //     formatDecimalWithComma(attributes?.carbohydrate) ||
  //     formatDecimalWithComma(editData?.carbohydrate) ||
  //     "",
  //   sugar:
  //     formatDecimalWithComma(attributes?.sugar) ||
  //     formatDecimalWithComma(editData?.sugar) ||
  //     "",
  //   protein:
  //     formatDecimalWithComma(attributes?.protein) ||
  //     formatDecimalWithComma(editData?.protein) ||
  //     "",
  //   salt:
  //     formatDecimalWithComma(attributes?.salt) ||
  //     formatDecimalWithComma(editData?.salt) ||
  //     "",
  //   ingredients: attributes?.ingredients || editData?.ingredients || "",
  //   fermentation: attributes?.fermentation || editData?.fermentation || "",
  //   colour: attributes?.colour || editData?.colour || "",
  //   taste: attributes?.taste || editData?.taste || "",
  //   pairing: attributes?.pairing || editData?.pairing || "",
  //   is_active: attributes?.is_active || editData?.is_active || true,
  //   is_approved: attributes?.is_approved || editData?.is_approved || true,
  // };

  // const convertToFormData = (values) => {
  //   const formData = new FormData();

  //   if (values.sub_categories && Array.isArray(values.sub_categories)) {
  //     values.sub_categories.forEach((item) => {
  //       formData.append("sub_categories", item?.value);
  //     });
  //   }
  //   Object.keys(values).forEach((key) => {
  //     if (key !== "sub_categories") {
  //       if (values[key] instanceof File || values[key] instanceof Blob) {
  //         formData.append(key, values[key]);
  //       } else if (Array.isArray(values[key])) {
  //         values[key].forEach((item, index) => {
  //           formData.append(`${key}[${index}]`, item);
  //         });p
  //       } else if (values[key] !== undefined && values[key] !== null) {
  //         formData.append(key, values[key]);
  //       }
  //     }
  //   });

  //   return formData;
  // };
  const convertToFormData = async (values) => {
    const formData = new FormData();

    const imageFields = [
      "front_bottle_image",
      "back_bottle_image",
      "front_label_image",
      "back_label_image",
    ];

    await Promise.all(
      imageFields.map(async (field) => {
        const value = values[field];
        if (value instanceof File) {
          formData.append(field, value);
        } else if (typeof value === "string" && value.startsWith("http")) {
          const file = await ImageUrlToFile(value);
          if (file) {
            formData.append(field, file);
          } else {
            formData.append(field, "");
          }
        } else {
          formData.append(field, "");
        }
      })
    );

    if (values.sub_categories && Array.isArray(values.sub_categories)) {
      values.sub_categories.forEach((item) => {
        formData.append("sub_categories", item?.value);
      });
    }

    Object.keys(values).forEach((key) => {
      if (!imageFields.includes(key) && key !== "sub_categories") {
        const value = values[key];

        if (value instanceof File || value instanceof Blob) {
          formData.append(key, value);
        } else if (Array.isArray(value)) {
          value.forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      }
    });

    return formData;
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    validationSchema: AttributesSchema,
    onSubmit: async (values) => {
      const formData = await convertToFormData(values);

      try {
        if (sectionData?.uuid) {
          let response;
          if (editData) {
            response = await UpdateAttributeAPI(
              sectionData?.uuid,
              productId,
              formData
            );
          } else {
            response = await CreateAttributeAPI(
              sectionData?.uuid,
              productId,
              formData
            );
          }
          if (response.success) {
            successToaster(response.message);
            !editData && handleReset();
          }
        } else {
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  const loadCodeOptions = async (
    search,
    prevOptions = [],
    additional = { page: 1 }
  ) => {
    const page = additional.page || 1;
    try {
      const response = await GetAttributesFilterOptionsAPI(
        page,
        pageSize,
        search
      );
      if (response.success) {
        const newOptions = response?.data?.winedata.map((item) => ({
          value: item?.uuid || "",
          label: `${item.name || ""}  ${item.ean || ""}  ${item.winery || ""}`,
        }));

        return {
          options: [...newOptions],
          hasMore: response?.data?.has_next,
          additional: { page: page + 1 },
        };
      }
    } catch (error) {
      console.error("Error fetching attribute:", error);
    }
    return {
      options: prevOptions,
      hasMore: false,
      additional: { page: page + 1 },
    };
  };
  const fetchAttributes = async () => {
    try {
      const response = await GetAttributeAPI(codFilterOption?.value);
      if (response.success) {
        const data = response.data;
        const newValues = {
          name: data?.name || "",
          description: data?.description || "",
          front_bottle_image: data?.front_bottle_image
            ? mediaUrl(data?.front_bottle_image)
            : null,
          back_bottle_image: data?.back_bottle_image
            ? mediaUrl(data?.back_bottle_image)
            : null,
          front_label_image: data?.front_label_image
            ? mediaUrl(data?.front_label_image)
            : null,
          back_label_image: data?.back_label_image
            ? mediaUrl(data?.back_label_image)
            : null,
          ean: data?.ean || "",
          winery: data?.winery || "",
          vintage: formatDecimalWithComma(data?.vintage) || "",
          denomination: data?.denomination || "",
          gradation: formatDecimalWithComma(data?.gradation) || "",
          vinification: data?.vinification || "",
          terroir: data?.terroir || "",
          region: data?.region || "",
          format: formatDecimalWithComma(data?.format) || "",
          country: data?.country ?? null,
          natural: data?.natural ?? null,
          bio: data?.bio ?? null,
          have_sulphite: data?.have_sulphite ?? null,
          biodynamic: data?.biodynamic ?? null,
          conventional: data?.conventional ?? null,
          energy: data?.energy || "",
          fat: formatDecimalWithComma(data?.fat) || "",
          saturated_fat: formatDecimalWithComma(data?.saturated_fat) || "",
          carbohydrate: formatDecimalWithComma(data?.carbohydrate) || "",
          sugar: formatDecimalWithComma(data?.sugar) || "",
          protein: formatDecimalWithComma(data?.protein) || "",
          salt: formatDecimalWithComma(data?.salt) || "",
          ingredients: data?.ingredients || "",
          fermentation: data?.fermentation || "",
          colour: data?.colour || "",
          taste: data?.taste || "",
          pairing: data?.pairing || "",
          // is_active: data?.is_active ?? true,
          // is_approved: data?.is_approved ?? true,
        };

        setFormInitialValues(newValues);
        resetForm({ values: newValues });
      }
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
    }
  };
  useEffect(() => {
    if (codFilterOption?.value) {
      fetchAttributes();
    }
  }, [codFilterOption]);
  const handleReset = () => {
    const emptyValues = {
      name: "",
      description: "",
      front_bottle_image: null,
      back_bottle_image: null,
      front_label_image: null,
      back_label_image: null,
      ean: "",
      winery: "",
      vintage: "",
      denomination: "",
      gradation: "",
      vinification: "",
      terroir: "",
      region: "",
      format: "",
      country: null,
      natural: null,
      bio: null,
      have_sulphite: null,
      biodynamic: null,
      conventional: null,
      energy: "",
      fat: "",
      saturated_fat: "",
      carbohydrate: "",
      sugar: "",
      protein: "",
      salt: "",
      ingredients: "",
      fermentation: "",
      colour: "",
      taste: "",
      pairing: "",
      // is_active: true,
      // is_approved: true,
    };

    setFormInitialValues(emptyValues);
    resetForm({ values: emptyValues });
  };

  // your existing formik code...

  const fetchEANData = async (ean) => {
    try {
      const response = await SearchWineData(ean);
      if (response.success) {
        const data = response?.data?.winedata;
        if (data) {
          const newValues = {
            name: data?.name || "",
            description: data?.description || "",
            front_bottle_image: data?.front_bottle_image
              ? mediaUrl(data?.front_bottle_image)
              : null,
            back_bottle_image: data?.back_bottle_image
              ? mediaUrl(data?.back_bottle_image)
              : null,
            front_label_image: data?.front_label_image
              ? mediaUrl(data?.front_label_image)
              : null,
            back_label_image: data?.back_label_image
              ? mediaUrl(data?.back_label_image)
              : null,
            ean: ean || "",
            winery: data?.winery || "",
            vintage: formatDecimalWithComma(data?.vintage) || "",
            denomination: data?.denomination || "",
            gradation: formatDecimalWithComma(data?.gradation) || "",
            vinification: data?.vinification || "",
            terroir: data?.terroir || "",
            region: data?.region || "",
            format: formatDecimalWithComma(data?.format) || "",
            country: data?.country ?? null,
            natural: data?.natural ?? null,
            bio: data?.bio ?? null,
            have_sulphite: data?.have_sulphite ?? null,
            biodynamic: data?.biodynamic ?? null,
            conventional: data?.conventional ?? null,
            energy: data?.energy || "",
            fat: formatDecimalWithComma(data?.fat) || "",
            saturated_fat: formatDecimalWithComma(data?.saturated_fat) || "",
            carbohydrate: formatDecimalWithComma(data?.carbohydrate) || "",
            sugar: formatDecimalWithComma(data?.sugar) || "",
            protein: formatDecimalWithComma(data?.protein) || "",
            salt: formatDecimalWithComma(data?.salt) || "",
            ingredients: data?.ingredients || "",
            fermentation: data?.fermentation || "",
            colour: data?.colour || "",
            taste: data?.taste || "",
            pairing: data?.pairing || "",
            // is_active: data?.is_active ?? true,
            // is_approved: data?.is_approved ?? true,
          };

          setFormInitialValues(newValues);
          resetForm({ values: newValues });
        }
      }
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
    }
  };

  const debouncedFetchEANData = useCallback(debounce(fetchEANData, 600), []);

  useEffect(() => {
    if (values.ean?.trim() && !isFirstRender) {
      debouncedFetchEANData(values.ean.trim());
    }
  }, [values.ean]);

  return (
    <>
      <div className="mt-2">
        <div className="row justify-content-between align-items-center gap-row-16  col-reverse">
          <div className="col-12 col-sm-6 col-md-6 col-lg-3">
            <CustomPaginatedSelect
              label={t("attributes.search")}
              name="searchCodFilter"
              placeholder={t("attributes.search")}
              value={codFilterOption}
              onChange={setCodFilterOption}
              loadOptions={loadCodeOptions}
              dropdownIndicatorDisplay="none"
              isClearable={true}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-5">
            <h2 className="text-capitalize text-sm-right mb-0">
              {editData ? t("attributes.update") : t("attributes.add")}
            </h2>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row d-flex flex-wrap">
            {AttributesFields.map(
              ({ name, type, unit, options, required, staticOptions1 }) => {
                return (
                  <div
                    key={name}
                    className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2"
                  >
                    {(type === "text" || type === "textarea") && (
                      <CustomInputField
                        label={`${t(`wine:fields.${name}`)}${
                          required ? " *" : ""
                        }`}
                        name={name}
                        placeholder={t(`wine:fields.${name}`)}
                        type={type}
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                        unit={unit}
                      />
                    )}
                    {type === "select" && (
                      <CustomPaginatedSelect
                        key={name}
                        label={`${t(`wine:fields.${name}`)}${
                          required ? "*" : ""
                        }`}
                        name={name}
                        options={options}
                        errors={errors}
                        touched={touched}
                        isSearchable={false}
                        onChange={(selectedOption) => {
                          setFieldValue(name, selectedOption?.value ?? null);
                        }}
                        onBlur={handleBlur}
                        value={
                          staticOptions1.find((opt) => {
                            const optionValue =
                              values[name] === true
                                ? true
                                : values[name] === false
                                ? false
                                : null;
                            return opt.value === optionValue;
                          }) || null
                        }
                        staticOptions={staticOptions1}
                      />
                    )}
                    {type === "selectCountry" && (
                      <CountryListSelect
                        label={`${t(`wine:fields.${name}`)}${
                          required ? "*" : ""
                        }`}
                        name="country"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        value={values["country"]}
                      />
                    )}
                  </div>
                );
              }
            )}
          </div>
          <div className="row">
            {AttributesImageFields?.map(({ name }) => {
              return (
                <div
                  key={name}
                  className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 "
                >
                  <div className="custom_input">
                    <InputGroup>
                      <ImageUploadCustom
                        label={t(`wine:fields.${name}`).toUpperCase()}
                        name={name}
                        changeBtnClasses="btn-simple"
                        addBtnClasses="btn-simple"
                        removeBtnClasses="btn-simple"
                        setFieldValue={setFieldValue}
                        value={values[name]}
                        errors={errorImg}
                        setError={setErrorImg}
                      />
                    </InputGroup>
                  </div>
                </div>
              );
            })}
          </div>

          <BtnCustom
            isLoading={isSubmitting}
            disabled={isSubmitting || !productId}
            type="submit"
            color="btn btn-primary mt-4 mr-3 block"
            submittingText={editData ? t("attributes.updating") : t("attributes.adding")}
          >
            {editData ? t("attributes.update") : t("attributes.add")}
          </BtnCustom>
          {!editData && (
            <BtnCustom
              disabled={isSubmitting}
              type="button"
              color="btn btn-secondary mt-4 block text-white"
              onClick={handleReset}
            >
              {t("attributes.reset")}
            </BtnCustom>
          )}
        </form>
      </div>
    </>
  );
};

export default AttributesFrom;
